<aside class="sayka-sidebar" [class.collapsed]="sidebarCollapsed" aria-label="Primary navigation">
  <div class="sayka-sidebar-header">
    <a class="sayka-brand" routerLink="/success/entries">
      <span class="t-brand-mark">S</span>
      <span class="sayka-brand-text">SAYKA</span>
    </a>
    <button class="sayka-collapse-toggle" type="button" (click)="toggleSidebarCollapse()"
      [attr.aria-label]="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'" title="Toggle sidebar">
      <i class="pi" [class.pi-chevron-left]="!sidebarCollapsed" [class.pi-chevron-right]="sidebarCollapsed" aria-hidden="true"></i>
    </button>
  </div>

  <nav class="sayka-sidebar-nav">
    <span class="sayka-nav-link is-disabled" [class.active]="activeShellNav === 'dashboard'" aria-disabled="true" title="Dashboard">
      <span class="sayka-nav-icon" aria-hidden="true"><i class="pi pi-th-large"></i></span>
      <span class="sayka-nav-text">Dashboard</span>
    </span>
    <a class="sayka-nav-link" [class.active]="activeShellNav === 'success'" routerLink="/success/entries" (click)="closeSidebar()" title="Success">
      <span class="sayka-nav-icon" aria-hidden="true"><i class="pi pi-check-circle"></i></span>
      <span class="sayka-nav-text">Success</span>
    </a>
    <a class="sayka-nav-link" [class.active]="activeShellNav === 'support-hub'"
      routerLink="/support-hub" (click)="closeSidebar()" title="Support Hub">
      <span class="sayka-nav-icon" aria-hidden="true"><i class="pi pi-question-circle"></i></span>
      <span class="sayka-nav-text">Support Hub</span>
    </a>
    <button class="sayka-nav-link sayka-nav-button" [class.active]="activeShellNav === 'analytics'" type="button"
      (click)="toggleAnalyticsMenu()" title="Analytics" [attr.aria-expanded]="analyticsExpanded">
      <span class="sayka-nav-icon" aria-hidden="true"><i class="pi pi-chart-bar"></i></span>
      <span class="sayka-nav-text">Analytics</span>
      <span class="sayka-nav-chevron" aria-hidden="true"><i class="pi" [class.pi-chevron-down]="analyticsExpanded" [class.pi-chevron-right]="!analyticsExpanded"></i></span>
    </button>
    <div class="sayka-subnav" *ngIf="analyticsExpanded && !sidebarCollapsed" aria-label="Analytics sub-menu">
      <a *ngIf="isDevOrLocal()" class="sayka-subnav-link" routerLink="/analytics/snapshot" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeSidebar()">Executive Overview</a>
      <a class="sayka-subnav-link" routerLink="/analytics/deployment" routerLinkActive="active" (click)="closeSidebar()">Program Deployment</a>
      <a *ngIf="isDevOrLocal()" class="sayka-subnav-link" routerLink="/analytics/adoption" routerLinkActive="active" (click)="closeSidebar()">Adoption &amp; Engagement</a>
    </div>
    <a class="sayka-nav-link" [class.active]="activeShellNav === 'dt-calculator'" routerLink="/dt-calculator" (click)="closeSidebar()" title="Downtime Cost Calculator">
      <span class="sayka-nav-icon" aria-hidden="true"><i class="pi pi-calculator"></i></span>
      <span class="sayka-nav-text">Downtime Cost Calculator</span>
    </a>
    <a class="sayka-nav-link" [class.active]="activeShellNav === 'shop-details'" routerLink="/shop-details" (click)="closeSidebar()" title="Shop Details">
      <span class="sayka-nav-icon" aria-hidden="true"><i class="pi pi-shop"></i></span>
      <span class="sayka-nav-text">Shop Details</span>
    </a>
    <a class="sayka-nav-link" [class.active]="activeShellNav === 'settings'" routerLink="/settings/company-admin" (click)="closeSidebar()" title="Settings">
      <span class="sayka-nav-icon" aria-hidden="true"><i class="pi pi-cog"></i></span>
      <span class="sayka-nav-text">Settings</span>
    </a>
  </nav>

  <div class="sayka-sidebar-footer">
    <i class="pi pi-user sayka-sidebar-footer-icon" title="Current User Details"></i>
    <div class="sayka-sidebar-footer-text">
      <span class="sayka-sidebar-welcome">{{ user?.displayName }}</span>
      <span class="sayka-sidebar-role-row">
        <span class="sayka-sidebar-role">{{ user?.roleName }}</span>
        <button class="sayka-role-details-btn" type="button" (click)="showUserRoles()"
          aria-label="View user role details" title="View role details">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
        </button>
      </span>
    </div>
  </div>
</aside>